import { createContext, useContext, useEffect, useState } from "react";

const KEY = "cee_color_mode";
const ColorModeContext = createContext({ mode: "dark", toggle: () => {} });

export const ColorModeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => localStorage.getItem(KEY) || "dark");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", mode === "dark");
    root.style.colorScheme = mode;
    localStorage.setItem(KEY, mode);
  }, [mode]);

  const toggle = () => setMode((m) => (m === "dark" ? "light" : "dark"));
  return <ColorModeContext.Provider value={{ mode, toggle }}>{children}</ColorModeContext.Provider>;
};

export const useColorMode = () => useContext(ColorModeContext);
